import React from "react";
import { NavLink } from "react-router-dom";

const SignedOutLinks = props => {
  return (
    <ul className="right">
      <li>
        <NavLink to="/signup">Sign Up</NavLink>
      </li>
      <li>
        <NavLink to="/signin">Log In</NavLink>
      </li>
    </ul>
  );
};

export default SignedOutLinks;



// WEBPACK FOOTER //
// ./src/components/layout/SignedOutLinks.jsx